import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import AvoEcosystem from './components/AvoEcosystem';
import Customers from './components/Customers';
import News from './components/News';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Career from './components/Career';
import SEABusinessData from './components/SEABusinessData';
import CustomerRequestPage from './components/CustomerRequestPage';
import AdminPage from './components/AdminPage';
import NavigationHub from './components/NavigationHub';
import './index.css';

const MainWebsite: React.FC = () => {
  return (
    <div className="min-h-screen bg-surface text-ink-700">
      <SEABusinessData />
      <Header />
      <main>
        <Hero />
        <Services />
        <AvoEcosystem />
        <Customers />
        <News />
        <About />
        <Projects />
        <Career />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainWebsite />} />
        <Route path="/hub" element={<NavigationHub />} />
        <Route path="/request" element={<CustomerRequestPage />} />
        <Route path="/admin/submissions" element={<AdminPage />} />
      </Routes>
    </Router>
  );
}

export default App; 